import React from 'react';
import { MapPin, Phone, Clock, Truck, Mail } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { contactInfo } from '../mockData';

const ContactSection = ({ translations, currentLang }) => {
  return (
    <section id="contact" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-brown-900 mb-4">
            {translations.contactTitle}
          </h2>
          <div className="w-24 h-1 bg-brown-700 mx-auto mt-6"></div>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          {/* Contact Information */}
          <div className="space-y-6">
            <Card className="border-2 border-cream-200">
              <CardContent className="p-6">
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0">
                    <div className="w-12 h-12 bg-brown-700 text-white rounded-full flex items-center justify-center">
                      <MapPin className="h-6 w-6" />
                    </div>
                  </div>
                  <div>
                    <h3 className="font-semibold text-lg text-brown-900 mb-2">{translations.address}</h3>
                    <p className="text-brown-700">{contactInfo.address[currentLang]}</p>
                    <p className="text-brown-600 text-sm mt-1">{contactInfo.locationCode}</p>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card className="border-2 border-cream-200">
              <CardContent className="p-6">
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0">
                    <div className="w-12 h-12 bg-brown-700 text-white rounded-full flex items-center justify-center">
                      <Phone className="h-6 w-6" />
                    </div>
                  </div>
                  <div>
                    <h3 className="font-semibold text-lg text-brown-900 mb-2">{translations.phone}</h3>
                    <a
                      href="tel:+903124463246"
                      className="text-brown-700 hover:text-brown-900 font-medium transition-colors"
                    >
                      {contactInfo.phone}
                    </a>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card className="border-2 border-cream-200">
              <CardContent className="p-6">
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0">
                    <div className="w-12 h-12 bg-brown-700 text-white rounded-full flex items-center justify-center">
                      <Mail className="h-6 w-6" />
                    </div>
                  </div>
                  <div>
                    <h3 className="font-semibold text-lg text-brown-900 mb-2">{translations.email}</h3>
                    <a
                      href={`mailto:${contactInfo.email}`}
                      className="text-brown-700 hover:text-brown-900 font-medium transition-colors"
                    >
                      {contactInfo.email}
                    </a>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card className="border-2 border-cream-200">
              <CardContent className="p-6">
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0">
                    <div className="w-12 h-12 bg-brown-700 text-white rounded-full flex items-center justify-center">
                      <Clock className="h-6 w-6" />
                    </div>
                  </div>
                  <div>
                    <h3 className="font-semibold text-lg text-brown-900 mb-2">{translations.hours}</h3>
                    <p className="text-brown-700">{contactInfo.hours[currentLang]}</p>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card className="border-2 border-cream-200">
              <CardContent className="p-6">
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0">
                    <div className="w-12 h-12 bg-brown-700 text-white rounded-full flex items-center justify-center">
                      <Truck className="h-6 w-6" />
                    </div>
                  </div>
                  <div>
                    <h3 className="font-semibold text-lg text-brown-900 mb-2">{translations.services}</h3>
                    <ul className="space-y-1">
                      {contactInfo.services[currentLang].map((service, index) => (
                        <li key={index} className="text-brown-700 flex items-center">
                          <span className="inline-block w-2 h-2 bg-brown-600 rounded-full mr-2"></span>
                          {service}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Button
              onClick={() => window.open(contactInfo.mapUrl, '_blank')}
              className="w-full bg-brown-700 hover:bg-brown-800 text-white py-6 text-lg font-semibold transition-all hover:scale-105 shadow-lg"
            >
              <MapPin className="mr-2 h-5 w-5" />
              {translations.getDirections}
            </Button>
          </div>

          {/* Map */}
          <div className="relative rounded-2xl overflow-hidden shadow-2xl h-[600px]">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3060!2d32.8665624!3d39.909952!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzkuOTA5OTUyLCAzMi44NjY1NjI0!5e0!3m2!1str!2str!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen={true}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Dere Pastanesi Konum"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
